// Maps URL hash fragments to universe filter values
const HASH_TO_UNIVERSE = {
  'gestion-pro': 'child_management',
  annonces: 'child_marketplace',
};

document.addEventListener('turbo:load', function() {
  const hash = window.location.hash.replace('#', '');
  const universe = HASH_TO_UNIVERSE[hash];
  if (!universe) return;

  const radio = document.getElementById(`universe_${universe}`);
  if (radio && !radio.checked) {
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
